import styled from 'styled-components';

export const TextErrorDetail = styled.div`
    color: ${ ({ theme: { dangerColor } }) => dangerColor };
    font-size: 12px;
    line-height: 20px;
    position: relative;
`;
